<template>
    <div class="edit-cabinet-dialog">
        <el-dialog
            :visible.sync="visible"
            :title="$t('Reception.Fifth.edit_sell_cabinet')"
            left>
            <el-form
                ref="form"
                :model="form"
                :status-icon="true"
                label-position="right"
                label-width="90px"
                label-suffix=":">
                <el-form-item :label="$t('Common.store')">
                    <span>{{ form.storeName }}</span>
                </el-form-item>
                <el-form-item :label="$t('Reception.Fourth.area1')">
                    <span>{{ form.storeAreaName }}</span>
                </el-form-item>
                <el-form-item :label="$t('Reception.Fifth.number')">
                    <span>{{ form.lockerCode }}</span>
                </el-form-item>
                <el-form-item :label="$t('Reception.Fifth.sale_status')">
                    <el-select
                        class="pr-2 reception-store"
                        v-model="form.salesStatus"
                        :placeholder="$t('Common.please_choose')">
                        <el-option
                            v-for="(item, index) in salesOptions"
                            :key="`${index}-${item.code}`"
                            :label="item.name"
                            :value="Number(item.code)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="status" :label="$t('Reception.Fifth.phy_status')">
                    <el-select
                        class="pr-2 reception-store"
                        v-model="form.physicalStatus"
                        :placeholder="$t('Common.please_choose')">
                        <el-option
                            v-for="(item, index) in physicalOptions"
                            :key="`${index}-${item.code}`"
                            :label="item.name"
                            :value="Number(item.code)">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">{{ $t('Common.cancel') }}</el-button>
                <el-button @click="confirm" type="primary">{{ $t('Common.submit') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            form: {
                salesStatus: null,
                physicalStatus: null,
            },
            stores: [],
            salesOptions: [
                {
                    code: 1,
                    name: this.$t('Reception.Fifth.wei_ding'),
                }, {
                    code: 2,
                    name: this.$t('Reception.Fifth.yi_ding'),
                },
            ],
            physicalOptions: [
                {
                    code: 1,
                    name: this.$t('Reception.Fifth.normal'),
                }, {
                    code: 2,
                    name: this.$t('Reception.Fifth.service'),
                }, {
                    code: 3,
                    name: this.$t('Reception.Fifth.scrapped'),
                }, {
                    code: 4,
                    name: this.$t('Reception.Fifth.pass'),
                },
            ],
            id: null,
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
            }
        },
    },
    methods: {
        resetForm() {
            this.$refs.form.resetFields();
        },
        async open(id) {
            this.id = id;
            this.fetchStore();
            this.fetchData();
            this.visible = true;
        },
        fetchData() {
            API.get(`locker/${this.id}`).then(res => {
                this.form = res;
            });
        },
        fetchStore() {
            // 门店
            API.get('store/list').then(res => {
                this.stores = res;
                this.form.storeId = res[0].id;
            });
        },
        confirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return false;
                this.postData();
            });
        },
        postData() {
            API.put(`locker/${this.id}`, this.form).then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.$emit('fetchData');
                this.visible = false;
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.el-dialog {
    width: 430px;
    margin: 0 !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.edit-cabinet-dialog {
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
}
</style>
